export const toNumericValue = (value: unknown) => {
	if (value === '' || value === null || value === undefined) return undefined;
	if (typeof value === 'number') return Number.isNaN(value) ? undefined : value;
	if (typeof value === 'string') {
		const parsed = Number(value);
		return Number.isNaN(parsed) ? undefined : parsed;
	}
	return undefined;
};
